// Import model
import { DataviewInstallationTypeOptionResponse } from '../models/DataviewInstallationTypeOptionResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { DataView } from '../models/DataView';
import { FilterInstallationTypeOptionRequest } from '../models/FilterInstallationTypeOptionRequest';
import { InstallationTypeOption } from '../models/InstallationTypeOption';

// Import dependency serializers (for complex types)
import { DataViewSerializer } from './DataViewSerializer';
import { FilterInstallationTypeOptionRequestSerializer } from './FilterInstallationTypeOptionRequestSerializer';
import { InstallationTypeOptionSerializer } from './InstallationTypeOptionSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewInstallationTypeOptionResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewInstallationTypeOptionResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewInstallationTypeOptionResponse instance
   */
  static deserialize(json: string): DataviewInstallationTypeOptionResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewInstallationTypeOptionResponse instance
   */
  static fromObject(obj: any): DataviewInstallationTypeOptionResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewInstallationTypeOptionResponse');
    }


    const instance: DataviewInstallationTypeOptionResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        InstallationTypeOptionSerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterInstallationTypeOptionRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewInstallationTypeOptionResponse instances
   */
  static deserializeArray(json: string): DataviewInstallationTypeOptionResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewInstallationTypeOptionResponse instance to a JSON string
   */
  static serialize(instance: DataviewInstallationTypeOptionResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewInstallationTypeOptionResponse instance to a plain object
   */
  static toObject(instance: DataviewInstallationTypeOptionResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        InstallationTypeOptionSerializer.toObject(item)
      ),
      'Request': instance.request ? FilterInstallationTypeOptionRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewInstallationTypeOptionResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewInstallationTypeOptionResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
